import React, { Component, Fragment } from "react";
import { ControlLabel, FormGroup, FormControl, Button } from "react-bootstrap";
import { Auth } from "aws-amplify";
import {
  getRepos,
  getUserProfileByEmail,
  updateUserProfileByEmail,
} from "../../libs/API";
import Header from "../header";
import LoaderButton from "../LoaderButton";
import * as constants from "../../constants";
import "./myaccount.css";
import EnableTotpPopup from "../Login/enabletotppopup";
import MfaSelectionPopup from "../Login/MfaSelectionPopup";

class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      newPassword: "",
      confirmPassword: "",
      errorMessage: "",
      isLoading: false,
      repoList: [],
      groups: [],
      showEnableTotpPopup: false,
      showDisableButton: "",
      preferredMfaType: "",
      showChangeMfaPhonePopup: false,
      // New state for MFA selection:
      showMfaSelection: false,
      selectedMfaType: null,
      // New state for user attributes:
      firstName: "",
      lastName: "",
      department: "",
      division: "",
      title: "",
      isAttributesLoading: false,
      attributesErrorMessage: "",
      attributesSuccessMessage: "",
      redactionColor: "",
    };
  }

  async componentDidMount() {
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true,
    });
    const preferredMfaType = user.preferredMFA || "NOMFA";
    if (preferredMfaType === "NOMFA") {
      this.setState({ showDisableButton: "false" });
    } else {
      this.setState({ showDisableButton: "true" });
    }
    this.setState({ preferredMfaType });
    await this.loadRepos();
    // Preload the user attributes to prebind the fields
    await this.loadUserAttributes();
  }

  loadUserAttributes = async () => {
    try {
      const userEmail = this.props.props.loggedInUser;

      await getUserProfileByEmail(userEmail)
        .then((response) => {
          console.log("User profile retrieved:", response.data);
          this.setState((prevState) => ({
            firstName:
              response.data.name !== null
                ? response.data.name
                : prevState.firstName,
            lastName:
              response.data.familyname !== null
                ? response.data.familyname
                : prevState.lastName,
            department:
              response.data.departmentName !== null
                ? response.data.departmentName
                : prevState.department,
            division:
              response.data.division !== null
                ? response.data.division
                : prevState.division,
            title:
              response.data.title !== null
                ? response.data.title
                : prevState.title,
            redactionColor:
              response.data.redactionColor !== null
                ? response.data.redactionColor
                : prevState.redactionColor,
          }));
        })
        .catch((err) => {
          console.error("Error retrieving profile:", err);
        });
    } catch (err) {
      console.error("Error loading user attributes:", err);
    }
  };

  handleSubmit = async (e) => {
    this.setState({ successMessage: "" });
    e.preventDefault();
    if (!this.state.newPassword.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)) {
      this.setState({
        errorMessage: "Minimum 8 Characters including 1 number.",
      });
      return;
    }
    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        errorMessage: constants.PASSWORD_MATCH_INVALID,
      });
      return;
    }
    await this.handleSavePassword();
  };

  resetInput = () => {
    let allInputs = document.querySelectorAll("input");
    if (allInputs.length > 0) {
      allInputs.forEach((input) =>
        input.id !== "username" ? (input.value = "") : input.value
      );
    }
  };

  handleAttributesSubmit = async (e) => {
    e.preventDefault();
    // Clear previous messages and set loading state
    this.setState({
      isAttributesLoading: true,
      attributesErrorMessage: "",
      attributesSuccessMessage: "",
    });
    try {
      const userDetails = {
        UserEmail: this.props.props.loggedInUser,
        Name: this.state.firstName,
        Familyname: this.state.lastName,
        Title: this.state.title,
        DepartmentName: this.state.department,
        Division: this.state.division,
        RedactionColor: this.state.redactionColor,
      };

      await updateUserProfileByEmail(userDetails)
        .then((response) => {
          console.log("Profile updated successfully:", response.data);
          this.setState({
            attributesSuccessMessage: "User Profile saved successfully",
            isAttributesLoading: false,
          });
        })
        .catch((err) => {
          console.error("Error updating profile:", err);
          this.setState({
            attributesErrorMessage: err.message,
            isAttributesLoading: false,
          });
        });
    } catch (err) {
      this.setState({
        attributesErrorMessage: err.message,
        isAttributesLoading: false,
      });
    }
  };

  handleSavePassword = async () => {
    this.setState({ isLoading: true, errorMessage: "", successMessage: "" });
    Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(
          user,
          this.state.password,
          this.state.newPassword
        );
      })
      .then(
        (data) => {
          this.setState({ isLoading: false });
          if (data === "SUCCESS") {
            this.resetInput();
            this.setState({
              successMessage: "Password Changed successfully",
              isLoading: false,
            });
          }
        },
        (err) => {
          console.log(err);
          this.setState({
            errorMessage: err.message,
            isLoading: false,
          });
        }
      );
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value, errorMessage: "" });
  };

  getAuthHeader = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  loadRepos = async () => {
    getRepos().then((data) => {
      this.setState({ repoList: data });
    });
    await this.loadGroups();
  };

  loadGroups = async () => {
    this.setState({ groups: this.props.props.groups });
  };

  formatGroupDisplay(group) {
    switch (group) {
      case "DocumentSync_ManageRedactions":
        return "Manage Redactions - Add, edit, and see through redaction annotations. Export with or without redactions";
      case "DocumentSync_TextSearch":
        return "Text Search - Perform text search of OCRed documents";
      case "DocumentSync_ManageUsers":
        return "Manage Users - Add and delete users, manage repository access and privileges";
      case "DocumentSync_EditIndex":
        return "Edit Index - Update index data from viewer";
      case "DocumentSync_ManageMetadataTemplates":
        return "Manage Index Templates - Create, delete, and edit Index Templates";
      case "DocumentSync_ManageRepositories":
        return "Manage Repositories - Create, delete, and edit names and S3 location of repositories";
      case "DocumentSync_Delete":
        return "Delete - Delete files, folders, and pages";
      case "DocumentSync_ManageFiles":
        return "Manage Files - Add, rename, and move files";
      case "DocumentSync_CliftonExpungementWorkflow":
        return "Clifton Expungement Workflow - Allows Clifton NJ PD Expungement and Juvenile Workflow";
      case "DocumentSync_LyndhurstExpungementWorkflow":
        return "Lyndhurst Expungement Workflow - Allows Lyndhurst NJ PD Expungement Workflow";
        case "DocumentSync_WayneExpungementWorkflow":
        return "Wayne Expungement Workflow - Allows Wayne NJ PD Expungement Workflow";
      case "DocumentSync_MedfordExpungementWorkflow":
        return "Medford Expungement Workflow - Allows Medford NJ PD Expungement Workflow";
      case "DocumentSync_EnglewoodExpungementWorkflow":
        return "Englewood Expungement Workflow - Allows Englewood NJ PD Expungement Workflow";

      case "DocumentSync_GlenrockExpungementWorkflow":
        return "Glenrock Expungement Workflow - Allows Glenrock PD Expungement Workflow";

      case "DocumentSync_AberdeenExpungementWorkflow":
        return "Aberdeen Expungement Workflow - Allows Aberdeen Township Expungement Workflow";
      case "DocumentSync_OCR":
        return "Ocr - Allows User to OCR templates based on Repositories";
      case "DocumentSync_PII":
        return "PII - Allows User to redact PII in files from  the image viewer";
      case "DocumentSync_Print":
        return "Print with Options - Print from viewer and show the machine's print dialogue box";
      case "DocumentSync_Email":
        return "Email - Email file from viewer or email file(s) from browse / search pages";
      case "DocumentSync_Download":
        return "Download - Download file from viewer, or download file(s) from browse / search pages";
      case "FoveonicsAdmin":
        return "Foveonics Admin - Has full access and privileges to all repositories, can run OCR jobs, and can run workflows";
      case "DocumentSync_DownloadIndex":
        return "This role allows the user to download the index information from the search page";
      case "DocumentSync_FileProperties":
        return "Show page count on the browse and search screens for users with the File Properties Role";
      case "DocumentSync_RestrictAccessByIP":
        return "Restrict Access By IP - Restrict access to the application by IP address";
      case "DocumentSync_EastamptonExpungementWorkflow":
        return "Eastampton Expungement Workflow - Allows Eastampton Expungement Workflow";
      case "DocumentSync_DemoExpungementWorkflow":
        return "Demo Expungement Workflow - Allows Demo Expungement Workflow for Foveonics Demo purpose";
      default:
        return null;
    }
  }
  // When the user clicks Enable MFA, first open the selection popup.
  handleEnableTotpPopup = (e) => {
    e.preventDefault();
    this.setState({ showMfaSelection: true, showChangeMfaPhonePopup: false });
  };

  // When MFA selection is complete, update state and show the MFA setup popup.
  handleMfaSelection = (selectedType) => {
    console.log("Selected MFA type:", selectedType);
    this.setState({
      selectedMfaType: selectedType, // "SMS" or "TOTP"
      showMfaSelection: false,
      showEnableTotpPopup: true,
      showChangeMfaPhonePopup: false,
    });
  };

  closeMfaSelection = () => {
    this.setState({ showMfaSelection: false });
  };

  handleDisableTotpPopup = async (e) => {
    if (!this.props.props.requireMfa) {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true,
      });
      await Auth.setPreferredMFA(user, "NOMFA");
      this.setState({ showDisableButton: "false", preferredMfaType: "NOMFA" });
      alert("MFA Disabled");
    } else {
      alert(
        "MFA is required for login. Please contact your administrator to disable MFA."
      );
    }
  };

  handleChangeMfaPhonePopup = async (e) => {
    e.preventDefault();
    const user = await Auth.currentAuthenticatedUser({
      bypassCache: true,
    });
    const preferredMfaType = user.preferredMFA || "NOMFA";

    if (preferredMfaType === "TOTP") {
      alert(
        "Phone number change is only available for SMS MFA. Your current MFA type is TOTP."
      );
      return;
    }

    this.setState({
      preferredMfaType,
      selectedMfaType: "SMS",
      showEnableTotpPopup: true,
      showMfaSelection: false,
      showChangeMfaPhonePopup: true,
    });
  };

  renderEnableDisableButton = () => {
    return (
      <Fragment>
        {this.state.showDisableButton === "false" && (
          <Button
            bsSize="small"
            bsClass="btn btn-outline-secondary"
            onClick={this.handleEnableTotpPopup}
            style={{ marginRight: "5px" }}
          >
            Enable MFA
          </Button>
        )}
        {this.state.showDisableButton === "true" && (
          <Button
            bsSize="small"
            bsClass="btn btn-outline-secondary"
            onClick={this.handleDisableTotpPopup}
            style={{ float: "right" }}
          >
            Disable MFA
          </Button>
        )}
        {this.state.preferredMfaType !== "TOTP" &&
          this.state.preferredMfaType !== "NOMFA" && (
            <div style={{ clear: "both", marginTop: "8px" }}>
              <Button
                bsSize="small"
                bsClass="btn btn-outline-secondary"
                onClick={this.handleChangeMfaPhonePopup}
              >
                Change MFA Phone Number
              </Button>
            </div>
          )}
      </Fragment>
    );
  };

  renderEnableTotpPopup() {
    return (
      <Fragment>
        {this.state.showEnableTotpPopup && (
          <EnableTotpPopup
            props={{
              showEnableTotpPopup: this.state.showEnableTotpPopup,
              // Pass the selected MFA type; default to "TOTP" if none selected.
            }}
            unmountMe={this.handleChildUnmount}
            mfaType={this.state.selectedMfaType}
            handleHideEnableButton={this.handleHideEnableButton}
            isPhoneNumberChangeFlow={this.state.showChangeMfaPhonePopup}
          />
        )}
      </Fragment>
    );
  }

  renderMfaSelectionPopup() {
    return (
      <Fragment>
        {this.state.showMfaSelection && (
          <MfaSelectionPopup
            isOpen={this.state.showMfaSelection}
            onClose={this.closeMfaSelection}
            onSelectMfaType={this.handleMfaSelection}
          />
        )}
      </Fragment>
    );
  }

  // Called by the MFA popups when they unmount
  handleChildUnmount = () => {
    this.setState({
      showEnableTotpPopup: false,
      showChangeMfaPhonePopup: false,
      // Optionally reset selectedMfaType if needed:
      selectedMfaType: null,
    });
  };

  handleHideEnableButton = () => {
    this.setState({
      showDisableButton: "true",
    });
  };

  render() {
    const { groups, repoList } = this.state;
    return (
      <Fragment>
        <Header props={this.props.props} history={this.props.history} />
        <div className="maindiv">
          <h4>My Account</h4>
          <br />
          <div className="myRepoandPrivilege">
            <fieldset className="my-fieldset">
              <legend className="login-legend">
                Repository Access and Privilege(s)
              </legend>
              <div style={{ float: "right" }}>
                {this.renderEnableDisableButton()}
              </div>
              <h6>Repository Access List</h6>
              <ol>
                {repoList.length > 0 &&
                  repoList.map((repo, i) => (
                    <li key={repo.folderName + i}>{repo.folderName}</li>
                  ))}
              </ol>
              <h6>Privilege(s)</h6>
              <ol>
                {groups.length > 0 &&
                  groups
                    .sort()
                    .filter(
                      (group) =>
                        group !== "DocumentSync" && !group.startsWith("OPRA_")
                    )
                    .map((group) => (
                      <li key={group}>{this.formatGroupDisplay(group)}</li>
                    ))}
              </ol>
            </fieldset>
          </div>

          <div className="myaccountContentRight">
            {/* Existing Change Password Form */}
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <fieldset className="my-fieldset">
                <legend className="login-legend">Change Password</legend>
                <FormGroup controlId="username">
                  <ControlLabel>Username:</ControlLabel>
                  <FormControl
                    componentClass="input"
                    readOnly
                    type="text"
                    value={this.props.props.loggedInUser}
                    autoComplete="off"
                  />
                </FormGroup>
                <FormGroup controlId="password">
                  <ControlLabel>Current Password:</ControlLabel>
                  <FormControl
                    componentClass="input"
                    type="password"
                    autoComplete="new-password"
                    required
                    minLength={8}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup controlId="newPassword">
                  <ControlLabel>New Password:</ControlLabel>
                  <span className="PasswordText">
                    (Minimum 8 Characters including 1 number.)
                  </span>
                  <FormControl
                    componentClass="input"
                    type="password"
                    autoComplete="new-password"
                    required
                    onChange={this.handleChange}
                    minLength={8}
                  />
                </FormGroup>
                <FormGroup controlId="confirmPassword">
                  <ControlLabel>Confirm Password:</ControlLabel>
                  <FormControl
                    componentClass="input"
                    type="password"
                    autoComplete="new-password"
                    required
                    minLength={8}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup>
                  <LoaderButton
                    block
                    bsClass="btn btn-outline-secondary"
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Save New Password"
                    loadingText="Saving New Password…"
                  />
                </FormGroup>
                <span className="errorMessage">{this.state.errorMessage}</span>
                <span className="successMessage">
                  {this.state.successMessage}
                </span>
              </fieldset>
            </form>

            {/* New User Attributes Form */}
            <form autoComplete="off" onSubmit={this.handleAttributesSubmit}>
              <fieldset className="my-fieldset">
                <legend className="login-legend">User Profile</legend>
                <FormGroup controlId="firstName">
                  <ControlLabel>First Name:</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.firstName}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup controlId="lastName">
                  <ControlLabel>Last Name:</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.lastName}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup controlId="department">
                  <ControlLabel>Department:</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.department}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup controlId="division">
                  <ControlLabel>Division:</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.division}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                <FormGroup controlId="title">
                  <ControlLabel>Title:</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                </FormGroup>
                {this.props.props.hasWhiteRedaction === true && (
                  <FormGroup controlId="redactionColor">
                    <ControlLabel>Redaction Color:</ControlLabel>
                    <FormControl
                      componentClass="select"
                      value={this.state.redactionColor || "Black"}
                      onChange={this.handleChange}
                    >
                      <option value="Black">Black</option>
                      <option value="White">White</option>
                    </FormControl>
                  </FormGroup>
                )}
                <FormGroup>
                  <LoaderButton
                    block
                    bsClass="btn btn-outline-secondary" // button color is preserved
                    type="submit"
                    isLoading={this.state.isAttributesLoading}
                    text="Save User Details"
                    loadingText="Saving Details…"
                  />
                </FormGroup>
                <span className="errorMessage">
                  {this.state.attributesErrorMessage}
                </span>
                <span className="successMessage">
                  {this.state.attributesSuccessMessage}
                </span>
              </fieldset>
            </form>

            {/* Render the MFA selection popup and then the MFA enable popup */}
            {this.renderMfaSelectionPopup()}
            {this.renderEnableTotpPopup()}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MyAccount;
